import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74afc381"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row justify-start full-width" }
const _hoisted_2 = { class: "col-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Micronutrientes", -1))
const _hoisted_4 = {
  key: 0,
  class: "full-width text-center"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Teores Extraídos do Solo", -1))
const _hoisted_9 = { class: "recomendations-line" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Macronutrientes", -1))
const _hoisted_14 = { class: "full-width text-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Nutrientes", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Extração da Cultura", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Exportação da Cultura", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Teores Extraídos do Solo", -1))
const _hoisted_19 = { class: "recomendations-line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Recomendação Nutricional", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "NORTOX Aplicado", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Saldo - deve ser zerado", -1))

import { ref } from 'vue';
import ResultadosPDF from './ResultadosPDF.vue';
import store from '@/store';
import { useRoute, useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const router = useRouter();

const tab = ref<string>('micronutrientes');


let auxLegendMicro = [...store.state.dataResults.microSubstancesString];
let auxMicro = [...store.state.dataResults.microBalance];

auxLegendMicro.splice(1,1);
auxMicro.splice(1,1); 

let optionsMicro = {
  chart: {
    type: 'bar',
  },
  xaxis: {
    categories: auxLegendMicro,
  },
  title: {
    text: 'Saldo',
    floating: true,
    align: 'center',
  },
};

let seriesMicro = [
  {
    name: 'saldo',
    data: auxMicro,
  },
];

let optionsMacro = {
  chart: {
    type: 'bar',
  },
  xaxis: {
    categories: store.state.dataResults.macroSubstancesString,
  },
  title: {
    text: 'Saldo',
    floating: true,
    align: 'center',
  },
};

let seriesMacro = [
  {
    name: 'saldo',
    data: store.state.dataResults.macroBalance,
  },
];

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_q_btn, {
          flat: "",
          color: "primary",
          label: "Voltar",
          class: "text-bold",
          icon: "chevron_left",
          dense: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/teste/${_unref(route).params.id}/recomendacoes`)))
        })
      ])
    ]),
    _createVNode(_component_q_card, null, {
      default: _withCtx(() => [
        _createVNode(_component_q_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
          class: "text-grey",
          "active-color": "primary",
          "indicator-color": "primary",
          align: "justify",
          "narrow-indicator": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab, {
              name: "micronutrientes",
              label: "Micronutrientes"
            }),
            _createVNode(_component_q_tab, {
              name: "macronutrientes",
              label: "Macronutrientes"
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_tab_panels, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tab).value = $event)),
          animated: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab_panel, { name: "micronutrientes" }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_apexchart, {
                    height: "400px",
                    type: "bar",
                    options: _unref(optionsMicro),
                    series: _unref(seriesMicro)
                  }, null, 8, ["options", "series"])
                ]),
                (_unref(store).state.dataResults.microSubstancesString?.length > 0)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_5,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microSubstancesString, (substance, substanceIndex) => {
                            return (_openBlock(), _createElementBlock("th", { key: substanceIndex }, _toDisplayString(substance), 1))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_6,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microExtraction, (substance, substanceIndex) => {
                            return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_7,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microExportation, (substance, substanceIndex) => {
                            return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_8,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microSoilContents, (substance, substanceIndex) => {
                            return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", _hoisted_9, [
                          _hoisted_10,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microRecomendations, (substance, substanceIndex) => {
                            return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_11,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microNortoxAppliedValues, (microApplied, index) => {
                            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microApplied), 1))
                          }), 128))
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_12,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.microBalance, (microBalance, index) => {
                            return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microBalance), 1))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, { name: "macronutrientes" }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("div", null, [
                  _createVNode(_component_apexchart, {
                    height: "400px",
                    type: "bar",
                    options: _unref(optionsMacro),
                    series: _unref(seriesMacro)
                  }, null, 8, ["options", "series"])
                ]),
                _createElementVNode("table", _hoisted_14, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_15,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroSubstancesString, (substance, substanceIndex) => {
                        return (_openBlock(), _createElementBlock("th", { key: substanceIndex }, _toDisplayString(substance), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_16,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroExtraction, (substance, substanceIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_17,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroExportation, (substance, substanceIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_18,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroSoilContents, (substance, substanceIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", _hoisted_19, [
                      _hoisted_20,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroRecomendations, (substance, substanceIndex) => {
                        return (_openBlock(), _createElementBlock("td", { key: substanceIndex }, _toDisplayString(substance), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_21,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroNortoxAppliedValues, (microApplied, index) => {
                        return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microApplied), 1))
                      }), 128))
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_22,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.dataResults.macroBalance, (microBalance, index) => {
                        return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(microBalance), 1))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(ResultadosPDF)
  ], 64))
}
}

})